import { render, staticRenderFns } from "./TqImage.vue?vue&type=template&id=169d8902&scoped=true&"
import script from "./TqImage.vue?vue&type=script&lang=js&"
export * from "./TqImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169d8902",
  null
  
)

export default component.exports